import type { PmsSourceKey } from '@/types/pms.types';

/**
 * Canonical vendor names. vendorRegistry reads its `displayName`s from here,
 * so there is still one source; this module exists so surfaces outside the
 * Integrations pages (the photos page, DV-3345) can name a vendor without
 * importing every vendor's settings panel.
 */
export const VENDOR_DISPLAY_NAMES: Record<PmsSourceKey, string> = {
  rentvine: 'Rentvine',
  appfolio: 'AppFolio',
  buildium: 'Buildium',
};

/**
 * The one resolver from a wire or route spelling to a vendor key.
 * Case-insensitive; null for an unknown vendor. The own-property check guards
 * against prototype-chain hits ('constructor', '__proto__', …).
 * getVendorDefinition resolves through it too, so the photos page and the
 * Integrations pages cannot disagree about which vendors exist.
 */
export const toVendorKey = (raw: string | null | undefined): PmsSourceKey | null => {
  const normalized = raw?.toLowerCase();
  if (!normalized || !Object.prototype.hasOwnProperty.call(VENDOR_DISPLAY_NAMES, normalized)) return null;
  return normalized as PmsSourceKey;
};

/** Case-insensitive; null for an unknown vendor. */
export const vendorDisplayName = (key: string | null | undefined): string | null => {
  const vendorKey = toVendorKey(key);
  return vendorKey ? VENDOR_DISPLAY_NAMES[vendorKey] : null;
};
